export default __webpack_public_path__ + "static/media/data-analytics.c06e86dd.svg";